import * as React from 'react';
import { useToastFooter_unstable } from './useToastFooter';
import { renderToastFooter_unstable } from './renderToastFooter';
import { useToastFooterStyles_unstable } from './useToastFooterStyles.styles';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * ToastFooter component
 */ export const ToastFooter = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useToastFooter_unstable(props, ref);
    useToastFooterStyles_unstable(state);
    useCustomStyleHook_unstable('useToastFooterStyles_unstable')(state);
    return renderToastFooter_unstable(state);
});
ToastFooter.displayName = 'ToastFooter';
